import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../../components/ui/dialog';
import { Copy } from '@phosphor-icons/react';
import { formatDate } from './constants';

const InvitationLinkDialog = ({ open, onOpenChange, invitation, onCopy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="invitation-link-dialog">
      <DialogHeader>
        <DialogTitle>Invitation Created</DialogTitle>
        <DialogDescription>
          Share this link with {invitation?.name} to complete registration.
        </DialogDescription>
      </DialogHeader>

      {invitation && (
        <div className="space-y-4">
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-xs text-slate-500 mb-1">Invitation Link</p>
            <div className="flex gap-2">
              <Input
                readOnly
                value={`${window.location.origin}/accept-invite/${invitation.code}`}
                className="font-mono text-sm"
                data-testid="invitation-link-input"
              />
              <Button
                variant="outline"
                size="icon"
                onClick={() => onCopy(invitation.code)}
                data-testid="copy-link-dialog-btn"
              >
                <Copy size={16} />
              </Button>
            </div>
          </div>

          <div className="text-sm text-slate-500">
            <p>
              This invitation expires on{' '}
              <strong>{formatDate(invitation.expires_at)}</strong>
            </p>
          </div>
        </div>
      )}

      <DialogFooter>
        <Button onClick={() => onOpenChange(false)} data-testid="link-dialog-done-btn">
          Done
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default InvitationLinkDialog;
